module.exports = __webpack_public_path__ + "static/ig_banner_04-77b5889bdeadfa495a666bd84ea66a51.png";